import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

const EXAM_API_BASE_URL =
  process.env.REACT_APP_EXAM_API_URL || 'https://v2.infopublisher.in';

const authHeaders = (token) => ({
  Authorization: `Bearer ${token}`,
  'Access-Control-Allow-Origin': `${process.env.REACT_APP_ADMIN_APP}`,
  'Access-Control-Allow-Methods': 'GET,PUT,POST,DELETE,PATCH,OPTIONS',
  'Access-Control-Allow-Headers':
    'Access-Control-Allow-Headers, Access-Control-Allow-Methods, Access-Control-Allow-Origin, Access-Control-Allow-Credentials, Origin, X-Requested-With, Content-Type, Accept, Authorization, access-control-allow-credentials,access-control-allow-headers,access-control-allow-methods,access-control-allow-origin,content-type',
  'Access-Control-Allow-Credentials': 'true',
});

export const ExamApi = createApi({
  reducerPath: 'ExamApi',
  baseQuery: fetchBaseQuery({
    baseUrl: EXAM_API_BASE_URL,
  }),
  endpoints: (builder) => ({
    getQuestionTypes: builder.mutation({
      query: ({ token }) => ({
        url: '/exam/question-types',
        method: 'GET',
        headers: authHeaders(token),
      }),
      transformResponse: (response) => response,
    }),
    bulkUploadQuestions: builder.mutation({
      query: ({ lessonId, questionType, formData, token }) => ({
        url: `/exam/lessons/${lessonId}/questions/${questionType}/bulk-upload`,
        method: 'POST',
        body: formData,
        headers: authHeaders(token),
      }),
      transformResponse: (response) => response,
    }),
    getExamQuestions: builder.mutation({
      query: ({ token, page = 1, limit = 10, lessonId, search = '', questionType, includeInactive }) => {
        const queryParams = new URLSearchParams({
          page: String(page),
          limit: String(limit),
        });

        if (lessonId) queryParams.append('lessonId', String(lessonId));
        if (search) queryParams.append('search', search);
        if (questionType) queryParams.append('questionType', questionType);
        if (typeof includeInactive === 'boolean') {
          queryParams.append('includeInactive', String(includeInactive));
        }

        return {
          url: `/exam/questions?${queryParams.toString()}`,
          method: 'GET',
          headers: authHeaders(token),
        };
      },
      transformResponse: (response) => response,
    }),
    bulkDeleteExamQuestions: builder.mutation({
      query: ({ token, questionIds }) => ({
        url: '/exam/questions/bulk-delete',
        method: 'POST',
        body: { questionIds },
        headers: authHeaders(token),
      }),
      transformResponse: (response) => response,
    }),
  }),
});

export const {
  useGetQuestionTypesMutation,
  useBulkUploadQuestionsMutation,
  useGetExamQuestionsMutation,
  useBulkDeleteExamQuestionsMutation,
} = ExamApi;

export const { ExamApiReducer } = ExamApi.reducer;
